import React, {useState} from 'react';
import SelectPicker from '../SelectPicker/SelectPicker';
import { contracts } from '../../ducks';
import registeredComponent from '../../utils/registeredComponent';
import duckify, { currentCustomer, singleDuck } from '../../utils/duckify';

const SplitContractSelector = ({
  contract,
  selectedBillingPayerId,
  selectBillingPayer
}) => {
  const currentSplit = contracts.hooks.useBillingPayerSplit(contract, selectedBillingPayerId);

  if (!currentSplit){
    return null;
  }

  return (
    <SelectPicker
      disabled={contract.contract_payer_splits.length <= 1}
      options={
        contract.contract_payer_splits.map(split => ({
          label: `${split.billing_payer.payer_contact.name} (${parseFloat(split.billing_payer.percent)}%)`,
          value: split.billing_payer_id
        }))
      }
      onChange={selected => selectBillingPayer(selected)}
      value={currentSplit && currentSplit.billing_payer_id}
    />
  );
};


const mapDucksToProps = ({contract_id}) => ({
  currentCustomer,
  contract: singleDuck(contracts, contract_id)
});

const mapStateToProps = (state, props) => ({
  selectedBillingPayerId: state.contracts.currentContract.selectedBillingPayerId
});

const mapDispatchToProps = (dispatch, props) => ({
  selectBillingPayer: (billingPayerId) => dispatch(contracts.actions.selectBillingPayer(billingPayerId))
});


export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(SplitContractSelector);
